(function () {
  'use strict';

  if (customElements.get('cz-store-locator')) return;

  class CzStoreLocator extends HTMLElement {
    constructor() {
      super();
      this.dialog = null;
      this.contentEl = null;
      this.lastFocusedElement = null;
      this.currentVariantId = null;
      this.fetchSeq = 0;
      this.cardSeq = 0;

      this._onDocClick = this._onDocClick.bind(this);
      this._onDialogClick = this._onDialogClick.bind(this);
      this._onDialogClose = this._onDialogClose.bind(this);
      this._onProductFormChange = this._onProductFormChange.bind(this);
      this._onProductDrawerLoaded = this._onProductDrawerLoaded.bind(this);
    }

    connectedCallback() {
      this.dialog = this.querySelector('[data-store-locator-dialog]');
      this.contentEl = this.querySelector('[data-store-locator-content]');
      if (!this.dialog || !this.contentEl) return;

      document.addEventListener('click', this._onDocClick);
      document.addEventListener('cz:product-drawer:loaded', this._onProductDrawerLoaded);
      this.dialog.addEventListener('click', this._onDialogClick);
      this.dialog.addEventListener('close', this._onDialogClose);

      // Populate the trigger card with first-available boutique
      this._populateTriggerCard();
      this._bindTriggerCardVariantWatcher();
    }

    /* Questo elemento e' globale e si registra una volta sola al caricamento.
       Su una pagina di collezione, in quel momento, non esistono ne' la card
       ne' il form prodotto: la card che compare dopo, dentro il drawer, non
       verrebbe mai popolata e il watcher di variante non si aggancerebbe mai.
       L'evento arriva da product-drawer.js dopo l'iniezione della sezione. */
    _onProductDrawerLoaded() {
      this._unbindTriggerCardVariantWatcher();
      this._populateTriggerCard();
      this._bindTriggerCardVariantWatcher();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._onDocClick);
      document.removeEventListener('cz:product-drawer:loaded', this._onProductDrawerLoaded);
      if (this.dialog) {
        this.dialog.removeEventListener('click', this._onDialogClick);
        this.dialog.removeEventListener('close', this._onDialogClose);
      }
      this._unbindVariantWatcher();
      this._unbindTriggerCardVariantWatcher();
    }

    _unbindTriggerCardVariantWatcher() {
      if (this._triggerCardObserver) {
        this._triggerCardObserver.disconnect();
        this._triggerCardObserver = null;
      }
      if (this._triggerCardInput && this._triggerCardChangeHandler) {
        this._triggerCardInput.removeEventListener('change', this._triggerCardChangeHandler);
        this._triggerCardInput = null;
        this._triggerCardChangeHandler = null;
      }
    }

    _onDocClick(event) {
      /* data-contact-drawer-open e' l'alias ereditato dal vecchio drawer
         contatti generico (Task 8): resta come selettore per non rompere
         i bottoni delle pagine guida, ma apre questo pannello. */
      const opener = event.target.closest('[data-store-locator-open], [data-contact-drawer-open]');
      if (opener) {
        event.preventDefault();
        this.open();
        return;
      }
      const closer = event.target.closest('[data-store-locator-close]');
      if (closer && this.dialog.open) {
        event.preventDefault();
        this.close();
        return;
      }
    }

    _esc(s) {
      return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    }

    /* Riga inline pickup: contesto è cozzarishop.com, "Cozzari Gioielleria" è ridondante.
       Stripping the prefix lets "presso <city>" stay su singola riga anche su desktop info column. */
    _shortLocationName(name) {
      return String(name || '').replace(/^\s*cozzari\s+gioielleria\s+/i, '').trim();
    }

    _onDialogClick(event) {
      if (event.target === this.dialog) {
        this.close();
      }
    }

    _onDialogClose() {
      this._unbindVariantWatcher();
      const productDrawer = document.getElementById('ProductDrawer');
      const productDrawerOpen = productDrawer && productDrawer.open;
      if (!productDrawerOpen) {
        document.documentElement.classList.remove('pd-no-scroll');
        document.body.classList.remove('pd-no-scroll');
      }
      if (this.lastFocusedElement && this.lastFocusedElement.focus) {
        this.lastFocusedElement.focus();
      }
    }

    open() {
      if (this.dialog.open) return;
      this.lastFocusedElement = document.activeElement;
      this.currentVariantId = this._readVariantId();
      this._render('loader');
      this.dialog.showModal();
      document.documentElement.classList.add('pd-no-scroll');
      document.body.classList.add('pd-no-scroll');
      this._fetchAndRender(this.currentVariantId);
      this._bindVariantWatcher();
    }

    close() {
      if (this.dialog.open) this.dialog.close();
    }

    /* Con il drawer aperto sopra una pagina prodotto il documento contiene due
       schede: quella sotto e quella nel dialog. Il documento e' ambiguo, il
       dialog no. Senza questa distinzione la card che si aggiorna e la
       variante che si legge possono appartenere a due prodotti diversi. */
    _scope() {
      const drawer = document.getElementById('ProductDrawer');
      const dentro = drawer && drawer.open &&
        drawer.querySelector('[data-pickup-card], form[action$="/cart/add"] input[name="id"]');
      return dentro ? drawer : document;
    }

    _variantInput() {
      return this._scope().querySelector('form[action$="/cart/add"] input[name="id"], form[data-type="add-to-cart-form"] input[name="id"]');
    }

    _readVariantId() {
      const input = this._variantInput();
      return input ? input.value : null;
    }

    _productHandle() {
      const meta = document.querySelector('meta[property="og:url"]');
      const href = (meta && meta.content) || window.location.pathname;
      const match = href.match(/\/products\/([^/?#]+)/);
      return match ? match[1] : null;
    }

    /* closedDays: null significa "non interpretabile", ed e' diverso da []
       che significa "nessuna chiusura settimanale". La distinzione e' tutto:
       con il vecchio parseInt + filter(Boolean) un "lunedi" scritto a mano
       nell'impostazione diventava [], cioe' "aperti tutti i giorni", e il
       lunedi mattina il pannello scriveva "Aperte ora". */
    _readSchedule() {
      var api = window.czBoutiqueHours;
      var raw = this.getAttribute('data-closed-days') || '';
      var parsed = api && api.parseClosedDays
        ? api.parseClosedDays(raw)
        : { days: [], valid: true };
      if (!parsed.valid && !this._closedDaysWarned) {
        /* Chi compila l'impostazione non guardera' mai questa console: il
           segnale per lui e' che gli orari spariscono dal pannello, cioe' il
           sito smette di affermare cio' che non sa leggere. Il warn serve a
           chi deve capirne il perche'. */
        this._closedDaysWarned = true;
        console.warn('[cozzari] giorni di chiusura non interpretabili:', JSON.stringify(raw),
          '- attesi numeri da 1 (lunedì) a 7 (domenica) separati da virgola. Gli orari non vengono mostrati.');
      }
      return {
        morningOpen: this.getAttribute('data-morning-open') || '',
        morningClose: this.getAttribute('data-morning-close') || '',
        afternoonOpen: this.getAttribute('data-afternoon-open') || '',
        afternoonClose: this.getAttribute('data-afternoon-close') || '',
        closedDays: parsed.valid ? parsed.days : null,
      };
    }

    /* Lo stato di apertura appartiene al momento, non al negozio: le quattro
       boutique condividono gli orari, quindi la riga e' una sola in cima. */
    _renderNow() {
      var el = this.dialog.querySelector('[data-store-locator-now]');
      var sched = this.dialog.querySelector('[data-store-locator-schedule]');
      if (!el || !window.czBoutiqueHours) return;
      var sc = this._readSchedule();
      var s = window.czBoutiqueHours.status(sc, new Date());

      /* Orario non interpretabile: niente riga in cima e niente frase in
         fondo. Il pannello resta l'elenco delle boutique con indirizzi e
         azioni, che e' gia' utile ed e' tutto vero. Scrivere "Chiuse ora,
         riaprono domani alle " con la coda vuota sarebbe insieme rotto e
         falso. Vengono nascosti entrambi, non solo svuotati, perche' il
         pannello si ridisegna a ogni fetch e lo stato precedente resterebbe. */
      if (!s) {
        el.hidden = true;
        el.innerHTML = '';
        if (sched) { sched.hidden = true; sched.textContent = ''; }
        return;
      }

      if (s.open) {
        el.innerHTML = '<b>Aperte ora</b>, chiudono alle ' + this._esc(s.closesAt);
      } else if (s.reopensDay === 'oggi') {
        el.innerHTML = '<b>Chiuse ora</b>, riaprono alle ' + this._esc(s.reopensAt);
      } else {
        el.innerHTML = '<b>Chiuse ora</b>, riaprono ' + this._esc(s.reopensDay) +
                       ' alle ' + this._esc(s.reopensAt);
      }
      el.hidden = false;

      if (sched) {
        /* I giorni di chiusura sono configurabili: scriverli a mano qui
           renderebbe la frase falsa il giorno in cui qualcuno cambia
           l'impostazione. Si derivano da closedDays. */
        var giorni = (window.czBoutiqueHours && window.czBoutiqueHours.giorni) || [];
        var chiusi = (sc.closedDays || [])
          .map(function (n) { return giorni[n] ? (n === 7 ? 'la ' : 'il ') + giorni[n] : ''; })
          .filter(Boolean);
        var frase = 'Tutte le boutique: ' + sc.morningOpen + ' – ' + sc.morningClose +
                    ' e ' + sc.afternoonOpen + ' – ' + sc.afternoonClose + '.';
        if (chiusi.length === 1) {
          frase += ' Chiuso ' + chiusi[0] + '.';
        } else if (chiusi.length > 1) {
          frase += ' Chiuso ' + chiusi.slice(0, -1).join(', ') + ' e ' + chiusi[chiusi.length - 1] + '.';
        }
        sched.textContent = frase;
        sched.hidden = false;
      }
    }

    async _fetchAndRender(variantId) {
      const handle = this._productHandle();
      const seq = ++this.fetchSeq;
      /* La sezione store-locator-availability legge solo le impostazioni
         del tema, non ha bisogno di un prodotto: fuori da una scheda
         prodotto (handle assente) o senza variante selezionata, si chiede
         comunque la lista, solo senza query di disponibilita'. */
      const base = handle ? `/products/${handle}` : (window.location.pathname || '/');
      const params = new URLSearchParams({ section_id: 'store-locator-availability' });
      if (variantId) params.set('variant', variantId);
      const url = `${base}?${params.toString()}`;
      try {
        const res = await fetch(url, { headers: { Accept: 'text/html' } });
        if (!res.ok) throw new Error('fetch failed: ' + res.status);
        const html = await res.text();
        if (seq !== this.fetchSeq) return; // a newer fetch superseded this
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const body = doc.querySelector('[data-store-locator-body]');
        if (!body) throw new Error('body element missing');
        this.contentEl.innerHTML = body.outerHTML;
        this._renderNow();
        if (variantId) {
          this._queryStoreAvailability(variantId).then((items) => {
            /* Guardia di sequenza: se nel frattempo e' partito un altro fetch,
               questa risposta e' superata. Senza, un cambio rapido di variante
               fa riordinare la lista corrente con la disponibilita' di quella
               precedente, e il raggruppamento afferma il falso. */
            if (seq !== this.fetchSeq) return;
            if (items && items.length) this._applyAvailability(items);
          });
        }
      } catch (err) {
        if (seq !== this.fetchSeq) return;
        this._render('error');
      }
    }

    _applyAvailability(items) {
      var list = this.contentEl.querySelector('.store-locator__list');
      if (!list) return;
      var cards = Array.prototype.slice.call(list.querySelectorAll('[data-boutique-card]'));
      var byName = {};
      items.forEach(function (it) { byName[it.name] = it.available; });

      /* Dividere in due gruppi e' un'affermazione su ogni boutique della
         lista, quindi si fa solo se la risposta le copre tutte. Se una sede
         non compare (il ritiro in negozio non e' abilitato la', o il nome non
         combacia con quello configurato) non e' stata interrogata: metterla
         sotto "Le altre boutique" direbbe che il pezzo non ce l'ha, che e'
         un'altra cosa. Meglio una lista unica senza gruppi che due gruppi
         sbagliati. */
      var matched = cards.filter(function (c) {
        return Object.prototype.hasOwnProperty.call(byName, c.getAttribute('data-location-name'));
      });
      if (matched.length !== cards.length) return;

      var here = [], other = [];
      cards.forEach(function (c) {
        var n = c.getAttribute('data-location-name');
        (byName[n] ? here : other).push(c);
      });

      var byPriority = function (a, b) {
        return (parseInt(a.getAttribute('data-priority'), 10) || 99) -
               (parseInt(b.getAttribute('data-priority'), 10) || 99);
      };
      here.sort(byPriority);
      other.sort(byPriority);

      list.innerHTML = '';
      if (here.length) {
        list.appendChild(this._groupLabel('Disponibile qui'));
        here.forEach(function (c) { c.classList.remove('store-locator__item--other'); list.appendChild(c); });
      }
      if (other.length) {
        list.appendChild(this._groupLabel(here.length ? 'Le altre boutique' : 'Le nostre boutique'));
        other.forEach(function (c) { c.classList.add('store-locator__item--other'); list.appendChild(c); });
      }
    }

    _groupLabel(text) {
      var li = document.createElement('li');
      li.className = 'store-locator__group';
      li.setAttribute('role', 'presentation');
      li.textContent = text;
      return li;
    }

    async _queryStoreAvailability(variantId) {
      const token = window.czStorefrontToken;
      if (!token || !variantId) return null;
      const shop = window.Shopify && window.Shopify.shop ? window.Shopify.shop : window.location.host;
      const query = `query Availability($id: ID!) {
        node(id: $id) {
          ... on ProductVariant {
            storeAvailability(first: 20) {
              edges {
                node {
                  available
                  location {
                    name
                    id
                  }
                }
              }
            }
          }
        }
      }`;
      try {
        const res = await fetch(`https://${shop}/api/2025-04/graphql.json`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': token,
            Accept: 'application/json',
          },
          body: JSON.stringify({
            query,
            variables: { id: `gid://shopify/ProductVariant/${variantId}` },
          }),
        });
        if (!res.ok) {
          /* Fallimento a livello HTTP (token scaduto o revocato: Shopify lo
             rifiuta all'edge con 401, prima ancora di eseguire la query
             GraphQL). Va comunque diagnosticato: e' lo stesso genere di
             errore vero del ramo "data.errors" qui sotto, solo che arriva
             come status code invece che nel corpo della risposta. */
          console.warn('[cozzari] Storefront API:', 'HTTP ' + res.status + (res.statusText ? ' ' + res.statusText : ''));
          return null;
        }
        const data = await res.json();
        if (data && data.errors && data.errors.length) {
          /* Errore vero dell'API: token revocato, scope mancante, query
             rifiutata. Va distinto dall'assenza di disponibilita', altrimenti
             il cliente legge "non disponibile" per un problema nostro. */
          console.warn('[cozzari] Storefront API:', data.errors[0].extensions
            ? data.errors[0].extensions.code : data.errors[0].message);
          return null;
        }
        const edges =
          (data && data.data && data.data.node && data.data.node.storeAvailability && data.data.node.storeAvailability.edges) || [];
        /* Niente `pickUpTime`: la card non promette piu' un tempo di
           preparazione, che il negozio dovrebbe poi mantenere. Chiedere
           all'API un dato che nessuno legge sarebbe solo peso morto. */
        return edges.map((e) => ({
          available: !!(e.node && e.node.available),
          name: (e.node && e.node.location && e.node.location.name) || '',
        }));
      } catch (err) {
        /* Stessa ragione degli altri due rami: un errore inghiottito qui
           (rete irraggiungibile, CORS, corpo non JSON) e' esattamente il
           pattern che ha tenuto nascosto per mesi il token scaduto. */
        console.warn('[cozzari] Storefront API:', err);
        return null;
      }
    }

    async _populateTriggerCard() {
      const card = this._scope().querySelector('[data-pickup-card]');
      if (!card) return;
      /* La riga compatta ha un solo campo di testo. Il bottone che la
         contiene non si tocca: porta data-store-locator-open dal Liquid, e
         il JS non deve ne' scriverlo ne' riscriverne il contenuto. */
      const line = card.querySelector('[data-pickup-card-line]');
      if (!line) return;

      /* Guardia di sequenza, gemella di quella del pannello: due cambi di
         variante ravvicinati possono far tornare la prima risposta dopo la
         seconda, e la card resterebbe sulla boutique, sull'orario e sul
         numero da chiamare della variante precedente. Un contatore dedicato
         e non `fetchSeq`, che appartiene al fetch della sezione: intrecciarli
         farebbe annullare l'uno dall'altro. */
      const seq = ++this.cardSeq;

      /* Stato di partenza e stato di attesa della rete: la card dice quello
         che sa in quel momento, cioe' niente. Azzerarla e basta la lasciava
         vuota per tutta la durata della richiesta; conservarla le avrebbe
         fatto mostrare il dato della variante precedente. Il reset copre
         anche il testo, non solo le classi. */
      const nonSappiamo = () => {
        card.classList.remove('is-available', 'is-unavailable');
        card.classList.add('is-unknown');
        line.textContent = 'Verifica la disponibilità nelle nostre quattro boutique.';
      };

      nonSappiamo();

      const variantId = this._readVariantId();
      const items = await this._queryStoreAvailability(variantId);
      if (seq !== this.cardSeq) return; // una richiesta piu' recente ha gia' risposto

      // Stato 5: il dato non e' utilizzabile. Sia un errore (null) sia una
      // risposta vuota ([]) finiscono qui: `storeAvailability` elenca solo le
      // sedi col ritiro in negozio abilitato, quindi un array vuoto dice che
      // quella funzione non e' configurata, NON che il pezzo manchi. Affermare
      // "non in negozio" su quella base sarebbe falso su ogni prodotto.
      if (!items || items.length === 0) return;

      /* Stessa guardia che il pannello applica prima di raggruppare: se
         nessun nome sede combacia con le boutique configurate, non sappiamo
         di quali negozi stia parlando la risposta. Senza, la card scriveva
         "Disponibile in boutique" accanto a un nome che il tema non
         riconosce, proponeva la prima sede nell'ordine arbitrario dell'API e
         non aveva un numero da chiamare. */
      const agganciate = items.filter((i) => this._boutiqueByLocation(i.name));
      if (agganciate.length === 0) {
        console.warn('[cozzari] nessuna sede della risposta combacia con le boutique configurate',
          '(variante ' + variantId + '):', items.map((i) => i.name).join(', '),
          '- confronta i nomi in Impostazioni > Sedi con il campo "Nome sede Shopify" di ogni boutique.');
        return;
      }

      const disponibili = agganciate.filter((i) => i.available);

      // Stato 4: nessuna boutique ce l'ha. Non e' un vicolo cieco: lo ordinano.
      if (disponibili.length === 0) {
        /* Se il pezzo risulta disponibile in una sede che non riconosciamo,
           non possiamo dire "non in negozio": quella sede potrebbe essere una
           boutique con il nome configurato male. Meglio non sapere. */
        if (items.some((i) => i.available)) return;
        card.classList.remove('is-unknown');
        card.classList.add('is-unavailable');
        line.textContent = 'Non in negozio al momento. Le boutique possono ordinarlo per te.';
        return;
      }

      /* Disponibile: si propone UNA sola boutique, scelta per priorita', non
         la prima che arriva dall'ordine arbitrario dell'API. Le altre stanno
         nel pannello, che la riga apre. */
      const scelta = this._pickByPriority(disponibili);
      /* Sempre valorizzata: `disponibili` e' un sottoinsieme di `agganciate`.
         Al cliente si mostra il nome della boutique, non il nome della sede
         Shopify, che e' un'etichetta di magazzino. Coincidono solo finche'
         il campo "Nome sede Shopify" resta vuoto. */
      const boutique = this._boutiqueByLocation(scelta.name);
      card.classList.remove('is-unknown');
      card.classList.add('is-available');

      /* Nessuna coda "pronto in 2 ore": e' una promessa di tempo che poi
         tocca al negozio mantenere, ed e' stata esclusa. Nessun orario di
         apertura: la riga compatta tiene una frase sola, e gli orari
         restano nel pannello, boutique per boutique. */
      line.innerHTML =
        '<span class="product-drawer__pickup-card__verb">Disponibile per il ritiro</span> presso <strong>' +
        this._esc(this._shortLocationName(boutique.name)) +
        '</strong>';
    }

    /* Fonte unica: l'isola JSON del Task 5. Leggere dal DOM del pannello
       obbligherebbe a scaricarlo su ogni scheda prodotto solo per conoscere
       un numero di telefono. */
    _boutiques() {
      if (this._boutiqueCache) return this._boutiqueCache;
      const el = document.querySelector('[data-cz-boutiques]');
      try {
        this._boutiqueCache = el ? JSON.parse(el.textContent) : [];
      } catch (err) {
        console.warn('[cozzari] elenco boutique illeggibile:', err.message);
        this._boutiqueCache = [];
      }
      return this._boutiqueCache;
    }

    _boutiqueByLocation(locationName) {
      return this._boutiques().find((b) => b.locationName === locationName) || null;
    }

    _pickByPriority(items) {
      const prioDi = (nome) => {
        const b = this._boutiqueByLocation(nome);
        return b ? b.priority : 99;
      };
      return items.slice().sort((a, b) => prioDi(a.name) - prioDi(b.name))[0];
    }

    _bindTriggerCardVariantWatcher() {
      const input = this._variantInput();
      if (!input) return;
      const handler = () => this._populateTriggerCard();
      this._triggerCardInput = input;
      this._triggerCardObserver = new MutationObserver(handler);
      this._triggerCardObserver.observe(input, { attributes: true, attributeFilter: ['value'] });
      input.addEventListener('change', handler);
      this._triggerCardChangeHandler = handler;
    }

    _render(state) {
      if (state === 'loader') {
        this.contentEl.innerHTML = '<p class="store-locator__loader">Caricamento…</p>';
      } else if (state === 'error') {
        this.contentEl.innerHTML =
          '<div class="store-locator__error"><p>Impossibile caricare la disponibilità.</p><button type="button" data-store-locator-retry>Riprova</button></div>';
        const retry = this.contentEl.querySelector('[data-store-locator-retry]');
        if (retry) {
          retry.addEventListener('click', () => {
            this._render('loader');
            this._fetchAndRender(this.currentVariantId);
          });
        }
      }
    }

    _bindVariantWatcher() {
      const input = this._variantInput();
      if (!input) return;
      this._watchedInput = input;
      this._watchedObserver = new MutationObserver(this._onProductFormChange);
      this._watchedObserver.observe(input, { attributes: true, attributeFilter: ['value'] });
      input.addEventListener('change', this._onProductFormChange);
    }

    _unbindVariantWatcher() {
      if (this._watchedObserver) {
        this._watchedObserver.disconnect();
        this._watchedObserver = null;
      }
      if (this._watchedInput) {
        this._watchedInput.removeEventListener('change', this._onProductFormChange);
        this._watchedInput = null;
      }
    }

    _onProductFormChange() {
      const newId = this._readVariantId();
      if (!newId || newId === this.currentVariantId) return;
      this.currentVariantId = newId;
      this._render('loader');
      this._fetchAndRender(newId);
    }
  }

  customElements.define('cz-store-locator', CzStoreLocator);
})();
